export default __webpack_public_path__ + "static/media/Rectangle4.6e88d159.png";